export enum LucideIconName {
  ListChevronsDownUp = 'ListChevronsDownUp',
  Newspaper = 'Newspaper',
  Lightbulb = 'Lightbulb',
  List = 'List',
  Link = 'Link',
  Calendar = 'Calendar',
  Phone = 'Phone',
  FileText = 'FileText',
  ShieldCheck = 'ShieldCheck',
  Utensils = 'Utensils',
  Mail = 'Mail',
  Image = 'Image',
  Images = 'Images',
  ImagePlus = 'ImagePlus',
  CaseSensitive = 'CaseSensitive',
  IdCardLanyard = 'IdCardLanyard',
  WalletCards = 'WalletCards',
  SquareArrowOutUpRight = 'SquareArrowOutUpRight',
  TextAlignStart = 'TextAlignStart',
  Grid2X2Check = 'Grid2X2Check',
  Crown = 'Crown',
  Tag = 'Tag',
  Film = 'Film',
  X = 'X',
  Menu = 'Menu',
  CirclePlus = 'CirclePlus',
  CircleX = 'CircleX',
  ChevronRight = 'ChevronRight',
  ChevronUp = 'ChevronUp',
  ChevronDown = 'ChevronDown',
  SquareArrowLeft = 'SquareArrowLeft',
  Trash2 = 'Trash2',
  Pen = 'Pen',
  Plus = 'Plus',
  CircleArrowDown = 'CircleArrowDown',
  CircleArrowUp = 'CircleArrowUp',
  Hand = 'Hand',
  Files = 'Files',
  Settings = 'Settings',
  Smartphone = 'Smartphone',
  Laptop = 'Laptop',
  SquarePen = 'SquarePen',
  CircleUser = 'CircleUser',
  CornerRightDown = 'CornerRightDown',
  CornerLeftUp = 'CornerLeftUp',
  GripVertical = 'GripVertical',
  CircleQuestionMark = 'CircleQuestionMark',
  Clapperboard = 'Clapperboard',
  LockKeyhole = 'LockKeyhole',
  ArrowRight = 'ArrowRight',
  ArrowLeft = 'ArrowLeft',
  Keyboard = 'Keyboard',
  CircleCheck = 'CircleCheck',
  Users = 'Users',
  Megaphone = 'Megaphone',
  Gift = 'Gift',
  ShoppingCart = 'ShoppingCart',
  UserRoundCog = 'UserRoundCog',
  User = 'User',
  Twitter = 'Twitter',
  Instagram = 'Instagram',
  Facebook = 'Facebook',
  Presentation = 'Presentation',
  PartyPopper = 'PartyPopper',
  Sun = 'Sun',
  Drama = 'Drama',
  Waves = 'Waves',
  TreeDeciduous = 'TreeDeciduous',
  Ship = 'Ship',
  Bed = 'Bed',
  Wine = 'Wine',
  Activity = 'Activity',
  Aperture = 'Aperture',
  BriefcaseBusiness = 'BriefcaseBusiness',
  Camera = 'Camera',
  BottleWine = 'BottleWine',
  Clock2 = 'Clock2',
}
